import { useState } from 'react';

import { monitorApi } from '../../api/monitor';
import type { ConsumptionReport } from '../../api/monitor';
import { isPending, reportSummary, STATUS_LABELS, STATUS_PILL } from '../../lib/reports';

/**
 * Um relatório na lista de gerados.
 *
 * O download é por `fetch` (ver `monitorApi.downloadReportXlsx`), e não por um
 * `<a href>`: a API exige o token do Google no cabeçalho `Authorization`, que
 * um link não manda.
 */
export function ReportRow({ report }: { report: ConsumptionReport }) {
  const [downloading, setDownloading] = useState(false);
  const [downloadError, setDownloadError] = useState<string | null>(null);

  const download = async () => {
    setDownloading(true);
    setDownloadError(null);
    try {
      await monitorApi.downloadReportXlsx(report.id);
    } catch (error) {
      setDownloadError((error as Error).message);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="border-surface-200 flex items-center gap-2.5 border-b px-4 py-[13px] last:border-b-0">
      <div className="min-w-0 flex-1">
        <div className="truncate text-[13.5px] font-bold">Consumo — {report.master}</div>
        <div className="text-ink-400 mt-px text-[11.5px]">{reportSummary(report)}</div>

        {downloadError ? (
          <div className="text-danger-600 mt-1 text-[11.5px] font-semibold">{downloadError}</div>
        ) : null}

        {report.status === 'error' && report.error ? (
          <div className="text-danger-600 mt-1 text-[11.5px] font-semibold">{report.error}</div>
        ) : null}
      </div>

      {isPending(report) ? (
        <span
          aria-hidden="true"
          className="border-line-300 border-t-navy-800 size-3.5 shrink-0 animate-spin rounded-full border-2"
        />
      ) : null}

      <span
        className={`shrink-0 rounded-full px-[9px] py-[3px] text-[10.5px] font-bold ${STATUS_PILL[report.status]}`}
      >
        {STATUS_LABELS[report.status]}
      </span>

      {report.status === 'ready' ? (
        <button
          type="button"
          onClick={() => void download()}
          disabled={downloading}
          className="border-line-300 text-navy-800 hover:border-navy-800 shrink-0 rounded-lg border bg-white px-2.5 py-1.5 text-[12px] font-bold disabled:opacity-60"
        >
          {downloading ? 'Baixando…' : 'Baixar'}
        </button>
      ) : null}
    </div>
  );
}
